import { Box } from '@mui/material';
import React from 'react';

const CustomDialogContent: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  return (
    <Box sx={{ padding: '20px 24px' }} >
      {children}
    </Box>
  );
};


export default CustomDialogContent;
